<div class="container-fluid">
  <div class="row">
    <main role="main" class="col">

      <div class="container-fluid">
        <div class="row my-5">
          <div class="col">
            <h1>
              {{'merchant.dashboard.title'|translate}}
            </h1>
          </div>
          <button class="btn btn-primary mr-2" (click)="getDailySalesReport('today')">{{'common.daily_report_today'|translate|uppercase}}<i-bs name="boxArrowDown" class="ml-1"></i-bs></button>
          <button class="btn btn-primary" (click)="getDailySalesReport('yesterday')">{{'common.daily_report_yesterday'|translate|uppercase}}<i-bs name="boxArrowDown" class="ml-1"></i-bs></button>

          <div class="btn-group ml-2">
            <button class="btn btn-primary" [disabled]="!canDownloadSalesReport || downloadingSales" (click)="downloadSalesReport()">{{'common.sales_report_range'|translate|uppercase}}<i-bs *ngIf="!downloadingSales" name="boxArrowDown" class="ml-1"></i-bs><span *ngIf="downloadingSales" class="spinner-border spinner-border-sm ml-1" role="status"></span></button>
            <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="sr-only">Toggle Dropdown</span>
            </button>
            <div class="dropdown-menu dropdown-menu-right p-2" (click)="$event.stopPropagation()">
              <form>
                <div class="form-group mb-2">
                  <label class="mb-1">{{'common.report_from'|translate}}</label>
                  <div class="input-group">
                    <input ngbDatepicker class="form-control" placeholder="yyyy-mm-dd" name="salesReportFrom" [(ngModel)]="salesReportFrom" #srf="ngbDatepicker">
                    <div class="input-group-append"><button class="btn btn-outline-secondary calendar" (click)="srf.toggle()" type="button"><i-bs name="calendar3"></i-bs></button></div>
                  </div>
                </div>
                <div class="form-group mb-2">
                  <label class="mb-1">{{'common.report_to'|translate}}</label>
                  <div class="input-group">
                    <input ngbDatepicker class="form-control" placeholder="yyyy-mm-dd" name="salesReportTo" [(ngModel)]="salesReportTo" #srt="ngbDatepicker">
                    <div class="input-group-append"><button class="btn btn-outline-secondary calendar" (click)="srt.toggle()" type="button"><i-bs name="calendar3"></i-bs></button></div>
                  </div>
                </div>
                <button class="btn btn-primary btn-sm" [disabled]="!canDownloadSalesReport || downloadingSales" (click)="downloadSalesReport()">{{'common.report_download'|translate}}</button>
              </form>
            </div>
          </div>
        </div>

        <div class="row my-5">
          <div class="col">
            <store-selector [initialStore]="this.storeSelection" (selectedStore)="selectedStore($event)">
            </store-selector>
          </div>
        </div>

        <div class="row" *ngIf="storeSelection">
          <div class="col-md-6">
            <div class="mb-4">
              <sales-periods-summary-list [date]="day1" [store]="storeSelection" (change)="day1Changed($event)"></sales-periods-summary-list>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-4">
              <sales-periods-summary-list [date]="day2" [store]="storeSelection" (change)="day2Changed($event)"></sales-periods-summary-list>
            </div>
          </div>
        </div>

      </div>

    </main>
  </div>
</div>
